import React from "react";

const Footer = () => {
  return (
    <div className="bg-gray-800 text-white py-4">
      <p className="">All rights reserved 2021</p>
    </div>
  );
};

export default Footer;
